import { createFileRoute } from '@tanstack/react-router';

import { CollationMismatchesTab } from '../../components/CollationMismatchesTab';

export const Route = createFileRoute('/db-insights/collations')({
  component: CollationMismatchesTab
});
